const shopifyConfig = window.glareCalculatorConfig || {};

const products = {
  base: {
    name: "Glare Ultra Concentrado",
    detail: "3 L · hasta 45 lavados",
    price: 9990,
    color: "#DDF75A",
    icon: "G",
    emoji: "🧼"
  },
  sport: {
    name: "Glare Pro Sport+",
    detail: "2,7 L · tecnología OdorBlock™",
    price: 12990,
    color: "#DDF75A",
    icon: "S",
    emoji: "🎾"
  },
  dark: {
    name: "Glare Pro Dark",
    detail: "2,7 L · tecnología BlackGuard™",
    price: 14990,
    color: "#FFFFFF",
    icon: "D",
    emoji: "♥"
  },
  intimate: {
    name: "Glare Pro Intimate",
    detail: "1 L · piel sensible, bebés y prendas íntimas",
    price: 7990,
    color: "#CFB9D6",
    icon: "I",
    emoji: "🌸"
  },
  pearl: {
    name: "Glare Pro Pearl",
    detail: "1 L · tecnología SoftBalance™",
    price: 4990,
    color: "#FFFFFF",
    icon: "P",
    emoji: "☁️"
  }
};

const packs = {
  daily: {
    name: "Pack Cuidado Diario",
    price: 26990,
    regular: 29970,
    variantId: shopifyConfig.dailyVariantId || "52287405359394",
    sellingPlanId: shopifyConfig.dailySellingPlanId || "",
    url: shopifyConfig.dailyUrl || "https://glarechile.cl/products/pack-familia-esencial",
    products: ["base", "dark", "pearl"],
    match: 93,
    headline: "Limpieza diaria, color y suavidad.",
    text: "Lo justo para resolver bien sin sumar productos que tu casa no necesita."
  },
  active: {
    name: "Pack Vida Activa",
    price: 36990,
    regular: 42960,
    variantId: shopifyConfig.activeVariantId || "52287413748002",
    sellingPlanId: shopifyConfig.activeSellingPlanId || "",
    url: shopifyConfig.activeUrl || "https://glarechile.cl/products/pack-familia-activa",
    products: ["base", "sport", "dark", "pearl"],
    match: 96,
    headline: "Para ropa con más movimiento.",
    text: "Suma Sport+ para olores difíciles y deja tu rutina cubierta sin comprar a medias."
  },
  full: {
    name: "Pack Cuidado Total 360°",
    price: 39990,
    regular: 50950,
    variantId: shopifyConfig.fullVariantId || "52287415517474",
    sellingPlanId: shopifyConfig.fullSellingPlanId || "",
    url: shopifyConfig.fullUrl || "https://glarechile.cl/products/pack-familia-360",
    products: ["base", "sport", "dark", "intimate", "pearl"],
    match: 98,
    headline: "Cobertura completa para la casa real.",
    text: "Ropa diaria, deporte, oscuros, piel sensible y suavidad en una sola compra."
  }
};

function getSubscriptionDiscount(packKey) {
  const configuredDiscount = Number(
    shopifyConfig[`${packKey}SubscriptionDiscount`] ?? shopifyConfig.subscriptionDiscount ?? 8
  );
  return Number.isFinite(configuredDiscount) ? Math.max(0, Math.min(configuredDiscount, 100)) : 0;
}

const questions = [
  {
    key: "home",
    title: "¿Cuántas personas viven en tu casa?",
    subtitle: "Mientras más ropa se junta, más sentido hace comprar un pack que resuelva de una vez.",
    hook: "Primer filtro: que el pack calce con la cantidad real de ropa, no con una compra al azar.",
    options: [
      { value: "solo", label: "Solo yo 😌", detail: "Pocas prendas, pero quiero que rindan." },
      { value: "couple", label: "Somos dos 🫶", detail: "Ropa variada, rutina simple." },
      { value: "family", label: "Somos 3 o 4 👥", detail: "La ropa aparece todos los días." },
      { value: "full", label: "FULL HOUSE 4+ 🏠", detail: "Aquí la lavadora trabaja en serio." }
    ]
  },
  {
    key: "tempo",
    title: "¿Qué tan seguido se prende la lavadora?",
    subtitle: "Pensarlo por día ayuda: no compra igual una casa tranquila que una casa donde la lavadora no para.",
    hook: "Si la lavadora trabaja seguido, el ahorro del pack empieza a notarse más rápido.",
    options: [
      { value: "light", label: "Día por medio 🧺", detail: "La rutina se mantiene ordenada." },
      { value: "normal", label: "Una carga al día 👕", detail: "La ropa se mueve todos los días." },
      { value: "intense", label: "La lavadora no para 😅", detail: "La lavadora: necesito refuerzos." }
    ]
  },
  {
    key: "freshness",
    title: "¿En tu casa hay ropa que vuelve con olor a transpiración o humedad?",
    subtitle: "A veces la ropa sale lavada, pero al usarla vuelve ese olor guardado. Ahí Sport+ hace sentido.",
    hook: "Sport+ elimina olores y ayuda a que no vuelvan. Tip: ideal para toallas de baño 😉",
    options: [
      { value: "sport", label: "Ropa de deporte 🏃", detail: "Sudor o entrenamiento intenso." },
      { value: "office", label: "Ropa de oficina 👔", detail: "Uso diario o muchas horas puesta." },
      { value: "no", label: "No, eso no me pasa 👍", detail: "Limpieza diaria sin Sport." }
    ]
  },
  {
    key: "care",
    title: "¿Cuidas la ropa íntima, de bebé o piel sensible?",
    subtitle: "Hay ropa que toca la piel más de cerca. Si hay bebé o piel delicada en casa, esa merece otro nivel de cuidado.",
    hook: "Aquí decidimos si vale la pena subir a cuidado 360 o dejar Intimate fuera.",
    options: [
      { value: "delicate", label: "Hay bebé o piel sensible 🌸", detail: "Quiero lavar con más cariño." },
      { value: "intimate", label: "Cuido mi ropa íntima 💛", detail: "Toca una zona importante y suele ser ropa cara." },
      { value: "skip", label: "No es prioridad para mí ✅", detail: "Prefiero enfocarme en limpieza diaria." }
    ]
  },
  {
    key: "finish",
    title: "¿Tu clóset tiene ropa negra u oscura que quieres cuidar?",
    subtitle: "Cuando el negro pierde intensidad, la prenda se ve más usada. Cuidar el color también es cuidar lo que ya compraste.",
    hook: "Tu ropa oscura también cuenta: cuidar el color evita sentir que una prenda buena envejeció antes de tiempo.",
    options: [
      { value: "dark", label: "Tengo mucho negro 🖤", detail: "Quiero mantenerlo intenso." },
      { value: "mixed", label: "Tengo prendas oscuras 👖", detail: "Me interesa que duren mejor." },
      { value: "low", label: "Poca ropa oscura ✨", detail: "Me importa más la rutina diaria." }
    ]
  }
];

const answers = {};
let step = 0;

const quiz = document.querySelector("#quiz");
const calculating = document.querySelector("#calculating");
const result = document.querySelector("#result");
const questionArea = document.querySelector("#questionArea");
const modal = document.querySelector("#calculatorModal");
const closeModalBtn = document.querySelector("#closeModalBtn");
const modalBackdrop = document.querySelector("#modalBackdrop");

document.querySelector("#startBtn").onclick = () => {
  openCalculator();
};

closeModalBtn.onclick = closeCalculator;
modalBackdrop.onclick = closeCalculator;
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && !modal.classList.contains("hidden")) closeCalculator();
});

function openCalculator() {
  resetCalculator();
  modal.classList.remove("hidden");
  quiz.classList.remove("hidden");
  renderQuestion();
}

function closeCalculator() {
  modal.classList.add("hidden");
}

document.querySelector("#backBtn").onclick = () => {
  if (step === 0) {
    closeCalculator();
    return;
  }

  step -= 1;
  renderQuestion();
};

document.querySelector("#restartBtn").onclick = () => {
  resetCalculator();
  renderQuestion();
};

function resetCalculator() {
  step = 0;
  Object.keys(answers).forEach((key) => delete answers[key]);
  modal.classList.remove("result-mode");
  modal.classList.remove("pack-daily", "pack-active", "pack-full");
  result.classList.add("hidden");
  calculating.classList.add("hidden");
  quiz.classList.remove("hidden");
}

function renderQuestion() {
  const question = questions[step];
  const percent = Math.round(((step + 1) / questions.length) * 100);
  const progressCopy = ["Vamos bien", "Buen dato", "Clave para elegir", "Casi está", "Último ajuste", "Resultado cerca"];

  document.querySelector("#stepLabel").textContent = `Pregunta ${step + 1} de ${questions.length}`;
  document.querySelector("#progressPercent").textContent = `${progressCopy[step]} · ${percent}%`;
  document.querySelector("#progressBar").style.width = `${percent}%`;
  questionArea.innerHTML = `
    <div class="question">
      <h2>${question.title}</h2>
      <p>${question.subtitle}</p>
      <div class="question-hook">${question.hook}</div>
      <div class="options options-${question.options.length}">
        ${question.options.map((option) => `
          <button class="option" data-value="${option.value}">
            <span class="option-title">${option.label}</span>
            <small>${option.detail}</small>
          </button>
        `).join("")}
      </div>
    </div>
  `;

  questionArea.querySelectorAll(".option").forEach((button) => {
    button.onclick = () => {
      answers[question.key] = button.dataset.value;

      if (step < questions.length - 1) {
        step += 1;
        renderQuestion();
        return;
      }

      showCalculating();
    };
  });
}

function showCalculating() {
  quiz.classList.add("hidden");
  calculating.classList.remove("hidden");
  const calcLine = document.querySelector("#calcLine");
  const lines = getCalculatingLines();
  let lineIndex = 0;
  calcLine.textContent = lines[lineIndex];
  const calcTimer = window.setInterval(() => {
    lineIndex = (lineIndex + 1) % lines.length;
    calcLine.textContent = lines[lineIndex];
  }, 1400);

  window.setTimeout(() => {
    window.clearInterval(calcTimer);
    calculating.classList.add("hidden");
    showResult();
  }, 4300);
}

function getRecommendedPack() {
  const needsSport = answers.freshness === "sport" || answers.freshness === "office";
  const needsIntimate = answers.care === "delicate" || answers.care === "intimate";

  if (needsIntimate) return "full";
  if (needsSport) return "active";
  return "daily";
}

function showResult() {
  const packKey = getRecommendedPack();
  const pack = packs[packKey];

  modal.classList.add("result-mode", `pack-${packKey}`);
  result.classList.remove("hidden");
  document.querySelector("#resultTitle").textContent = pack.name;
  document.querySelector("#resultText").textContent = `${pack.headline} ${pack.text}`;
  document.querySelector("#matchValue").textContent = "0%";
  animateMatch(pack.match);
  document.querySelector("#packProducts").innerHTML = pack.products.map((key) => {
    const product = products[key];
    return `
    <div class="product">
      <div class="product-badge badge-${key}" style="background:${product.color}">${product.emoji}</div>
      <div>
        <h3>${product.name}</h3>
        <p>${product.detail}</p>
      </div>
      <strong>${money(product.price)}</strong>
    </div>
  `;
  }).join("");
  document.querySelector("#regularPrice").textContent = money(pack.regular);
  document.querySelector("#packPrice").textContent = money(pack.price);
  document.querySelector("#savingText").innerHTML = getSavingText(packKey, pack);
  document.querySelector("#shopButton").href = getOneTimeCheckoutUrl(pack);
  document.querySelector("#shopButton").innerHTML = `Compra Única Pack <span>↗</span>`;
  const subscribeButton = document.querySelector("#subscribeButton");
  if (shopifyConfig.subscriptionEnabled === false) {
    subscribeButton.style.display = "none";
  } else {
    subscribeButton.style.display = "";
    subscribeButton.href = getSubscriptionCheckoutUrl(pack);
    subscribeButton.innerHTML = `<span><b>Suscripción Mensual: ¡Quiero Ahorro Total!</b></span><i>↗</i>`;
  }
  document.querySelector("#why").innerHTML = getReasons(pack).map((reason) => `
    <div class="reason">
      <b>${reason.title}</b>
      <p>${reason.text}</p>
    </div>
  `).join("");
}

function getSavingText(packKey, pack) {
  const packSaving = pack.regular - pack.price;
  const subscriptionDiscount = getSubscriptionDiscount(packKey);

  if (subscriptionDiscount <= 0) {
    return `<span>Ahorras <strong>${money(packSaving)}</strong> comprando el pack.</span>`;
  }

  const subscriptionSaving = Math.round(pack.price * subscriptionDiscount / 100);
  const subscriptionPrice = pack.price - subscriptionSaving;
  return `<span>Ahorras <strong>${money(packSaving)}</strong> comprando el pack + <strong>${money(subscriptionSaving)} extra</strong> con suscripción.</span><b>Tu precio final con suscripción: <em>${money(subscriptionPrice)}</em></b>`;
}

function getOneTimeCheckoutUrl(pack) {
  if (!pack.variantId) return pack.url;
  return `https://glarechile.cl/cart/${pack.variantId}:1?checkout`;
}

function getSubscriptionCheckoutUrl(pack) {
  if (pack.variantId && pack.sellingPlanId) {
    return `https://glarechile.cl/cart/add?id=${pack.variantId}&quantity=1&selling_plan=${pack.sellingPlanId}&return_to=/checkout`;
  }
  return shopifyConfig.subscribeUrl || pack.url;
}

function animateMatch(target) {
  const element = document.querySelector("#matchValue");
  const start = performance.now();
  const duration = 950;

  function tick(now) {
    const progress = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    element.textContent = `${Math.round(target * eased)}%`;
    if (progress < 1) window.requestAnimationFrame(tick);
  }

  window.requestAnimationFrame(tick);
}

function getCalculatingLines() {
  const lines = ["Mirando tu rutina como quien mira el canasto de la semana."];
  if (answers.home === "full" || answers.tempo === "intense") {
    lines.push("Con ese ritmo de lavado, conviene que el pack llegue a tiempo y no se quede corto.");
  }
  if (answers.freshness === "sport" || answers.freshness === "office") {
    lines.push("Si hay olor guardado o transpiración, Sport+ empieza a hacer mucho sentido.");
  }
  if (answers.freshness === "no") {
    lines.push("Si no hay olor persistente, mejor no sumarte algo que no necesitas.");
  }
  if (answers.care === "delicate" || answers.care === "intimate") {
    lines.push("Hay ropa que toca más de cerca la piel. Esa merece otro nivel de cuidado.");
  }
  if (answers.care === "skip") {
    lines.push("Si Intimate no es prioridad, buscamos una recomendación más simple y precisa.");
  }
  lines.push("Revisando qué conviene más: comprar suelto o resolverlo en pack.");
  lines.push("Buscando ese equilibrio rico: cubrir bien, ahorrar y no comprar de más.");
  return lines;
}

function getReasons(pack) {
  const homeReason = {
    solo: "En una casa chica, el pack correcto no tiene que ser enorme: tiene que ser útil y rendidor.",
    couple: "Para dos, conviene comprar productos que cubran la rutina sin llenar el lavadero de botellas.",
    family: "Con 3 o 4 personas, la ropa aparece todos los días. Ahí el pack empieza a ganarle a la compra suelta.",
    full: "Cuando la casa está llena, quedarse corto se nota rápido. Por eso tu recomendación prioriza cobertura."
  }[answers.home];

  const careReason = getCareReason();

  return [
    { title: "01 · Tu casa", text: homeReason },
    { title: "02 · Tu ropa", text: careReason },
    { title: "03 · Compra inteligente", text: `Este pack ahorra ${money(pack.regular - pack.price)} frente a comprar sus productos por separado.` },
    { title: "04 · Suavizante incluido", text: "Pearl es el complemento que deja la ropa suave y agradable al usar. Por eso va incluido en nuestros packs, con amor." }
  ];
}

function getCareReason() {
  if (answers.care === "delicate") {
    return "Cuando hay bebé, piel sensible o prendas íntimas, no se trata solo de lavar: se trata de elegir algo que deje más tranquilidad para tod@s.";
  }
  if (answers.care === "intimate") {
    return "La ropa íntima toca una zona importante y muchas veces cuesta más cuidarla. Por eso tiene sentido sumar una fórmula específica.";
  }
  if (answers.freshness === "sport" || answers.freshness === "office") {
    return "Hay prendas y toallas que parecen limpias, pero guardan olor a humedad o transpiración. Sport+ ayuda a eliminarlo y evita que vuelva.";
  }
  if (answers.freshness === "no") {
    return "Como no tienes un problema de olor persistente, tu recomendación se enfoca en limpieza diaria, color y suavidad.";
  }
  return "Quieres resolver la limpieza sin complicarte, y ahí el pack correcto evita comprar de más.";
}

function money(value) {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0
  }).format(value);
}
